import { consumer, I18NextProvider, inject } from "@spawn/core";
import { GameMessageService, GameMessageType } from "@spawn/modern-ui";
import { BankruptState as BaseBankruptState, ModalCloseEvent, ModalType, UiEvents } from "@spawn/slot-machine";
import { filter } from "rxjs";

@consumer
export class BankruptState extends BaseBankruptState {
	@inject private readonly gameMessageService!: GameMessageService;
	@inject private readonly i18n!: I18NextProvider;

	public override onEnter(): void {
		super.onEnter();

		// HACK: more specific message for bankrupt state instead of conditional message in GameMessageService
		// remove when https://gamomat.atlassian.net/browse/ENG-3984 is resolved
		this.setBankruptMessage();

		this.subscriptions.add(
			this.eventDispatcher
				.event$<ModalCloseEvent>(UiEvents.ModalClose)
				.pipe(filter((event) => event.payload.modalType === ModalType.FreeRoundsEnd))
				.subscribe(() => this.setBankruptMessage())
		);
	}

	private setBankruptMessage(): void {
		this.gameMessageService.setCustomGameMessage(this.i18n.t("general.bankrupt"), GameMessageType.Primary);
	}
}
